import axios from "axios";

let APIKit = axios.create({
  baseURL: "https://gmopen.azurewebsites.net/api",
});

APIKit.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    config.headers["ngrok-skip-browser-warning"] = "12321";
    if (token) {
      config.headers["Authorization"] = token;
    }
    return config;
  },
  (error) => {
    Promise.reject(error);
    console.log(error);
  }
);

export default APIKit;
